export default () => {
  const queue = []
  const inTransition = el => {
    queue.push(el)
    const { top } = el.getBoundingClientRect()
    el.style.position = `fixed`
    el.style.top = `${top}px`
    el.style.left = 0
    el.style.right = 0
    // el.style.zIndex = -1
  }
  const outTransition = el => {
    el.style.position = ``
    el.style.top = ``
    el.style.left = ``
    el.style.right = ``
    el.style.zIndex = ``
    queue.splice(
      queue.indexOf(el),
      1
    )
  }
  const beforeLeave = el => {
    while (queue.length) {
      outTransition(queue[0])
    }
    inTransition(el)
  }
  const afterLeave = el => {
    outTransition(el)
  }

  return {
    beforeLeave,
    afterLeave
  }
}
